import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { RosterBankScreen } from '@/features/hr-reports/roster-bank-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/roster-bank')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RosterBankScreenRoute,
})

function RosterBankScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <RosterBankScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/roster-bank', search: next })}
    />
  )
}
